import React from "react"
import theme from "../../theme"
import { OverlayDiv, PanelDiv } from "./styles"

const Overlay = (log, closeCallback) => {
    return (
        <OverlayDiv>
            <PanelDiv>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "20% 75%",
                        gridGap: theme.space.s
                    }}
                >
                    <span>Time: </span>
                    <span>{log.time}</span>
                    <span>Module: </span>
                    <span>{log.module}</span>
                    <span>Type: </span>
                    <span>{log.type}</span>
                    <span>Message: </span>
                    <span style={{ overflowWrap: "break-word" }}>
                        {log.message}
                    </span>
                </div>
                <button
                    style={{
                        background: "rgb(105,119,140)",
                        borderRadius: "3px",
                        padding: "10px",
                        marginTop: "10px",
                        marginBottom: "10px"
                    }}
                    onClick={() => closeCallback()}
                >
                    <span>Close</span>
                </button>
            </PanelDiv>
        </OverlayDiv>
    )
}

export default Overlay



// WEBPACK FOOTER //
// ./src/OctoprintParser/LogOverlay/index.js